
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import AutomMatePage from '../pages/autommate/page';
import ZohoOnePage from '../pages/zohoone/page';
import ServicesPage from '../pages/services/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import ManageEnginePage from '../pages/manageengine/page';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';
import CookiePage from '../pages/cookie/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/products',
    element: <Products />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/autommate',
    element: <AutomMatePage />
  },
  {
    path: '/zohoone',
    element: <ZohoOnePage />
  },
  {
    path: '/manageengine',
    element: <ManageEnginePage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/cookie',
    element: <CookiePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
